import { ActionTree } from 'vuex';
import { CoreState } from '../../models';
import { RootStoreState } from '../store.interfaces';
import { CalculateCoreStylesAction } from './actions/calculate-core-styles.action';
import { SetInputQueryAction } from './actions/set-input-query.action';
import { WishlistAction } from './actions/wishlist.action';

export const CORE_ACTIONS: ActionTree<CoreState, RootStoreState> = {
  ...new CalculateCoreStylesAction().actions,
  ...new WishlistAction().actions,
  ...new SetInputQueryAction().actions
};
